// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3WOyg","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__KzMcd"};